import React from "react";
import PropTypes from "prop-types";

import Strf from "shared/components/Strf";
import Str from "shared/components/Str";
import PrimaryButton from "shared/components/PrimaryButton";

import "./UpgradeAListPremiumButton.scss";

const UpgradeAListPremiumButton = ({ onClick }) => {
	return (
		<div>
			<PrimaryButton
				className="upgrade-alist-premium-button"
				onClick={onClick}
			>
				<Strf
					vars={{ upgradeTo: (<div className="upgrade-alist-premium-button-text"><Str>Upgrade to</Str></div>) }}
				>
					$upgradeTo premium
				</Strf>
			</PrimaryButton>
		</div>
	);
};

UpgradeAListPremiumButton.propTypes = {
	onClick: PropTypes.func.isRequired,
};

export default UpgradeAListPremiumButton;



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/UpgradeAListPremiumButton/UpgradeAListPremiumButton.jsx